export const modalStyles = {
  padding: "0",
  display: "flex",
  flexDirection: "row",
  minHeight: 0,
};

export const updatedModalStyles = {
  display: "flex",
  flexDirection: "row",
  minHeight: 0,
};
